import React, { memo, useEffect } from 'react'
import firebase from 'firebase';
import FirebaseUIAuth from 'react-firebaseui-localized'
import { useAuth, useFirebaseApp } from 'reactfire'

const FirebaseUI = memo(() => {
  const { firebase_ } = useFirebaseApp()
  const auth = useAuth;

  return (
    <FirebaseUIAuth
      lang="en"
      config={{
        signInFlow: 'popup',// Popup signin flow rather than redirect flow.
        signInOptions: [// We will display Google, Facebook and Email as auth providers.
          auth.GoogleAuthProvider.PROVIDER_ID,
          auth.FacebookAuthProvider.PROVIDER_ID,
          auth.EmailAuthProvider.PROVIDER_ID,
        ],
        signInSuccessUrl: '/app/weather',
      }}
      auth={auth()}
      firebase={firebase_}
    />
  )
})

export default FirebaseUI